import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglePay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Google Pay (Stripe)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Â®",
			clipPath: "url(#clip0_13_5710_googlePay_dark)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M23.2902 11.8791V14.9585H22.3208V7.35639H24.8916C25.5117 7.34438 26.1079 7.58054 26.5594 8.01719C27.0109 8.42342 27.2637 9.01138 27.2518 9.61773C27.2637 10.2301 27.0109 10.818 26.5594 11.2303C26.1079 11.6606 25.5542 11.8791 24.898 11.8791H23.2902ZM23.2902 8.29014V10.9453H24.9159C25.2772 10.9573 25.6261 10.812 25.873 10.5511C26.3845 10.054 26.3909 9.23552 25.8972 8.72041L25.873 8.696C25.6261 8.42943 25.2772 8.28376 24.9159 8.29577C24.9159 8.29615 23.2902 8.29014 23.2902 8.29014ZM29.4852 9.58732C30.2014 9.58732 30.7674 9.78143 31.1828 10.1633C31.5981 10.5511 31.8028 11.0786 31.8028 11.7514V14.9521H30.8756V14.2309H30.8334C30.43 14.8249 29.9002 15.1222 29.232 15.1222C28.666 15.1222 28.1847 14.9525 27.8051 14.6131C27.4319 14.2977 27.2212 13.831 27.2331 13.34C27.2331 12.8004 27.4378 12.3762 27.8413 12.0548C28.2447 11.7334 28.7865 11.5757 29.4606 11.5757C30.0385 11.5757 30.5079 11.685 30.8815 11.8911V11.6669C30.8815 11.3335 30.7368 11.0182 30.4841 10.806C30.2253 10.5755 29.8942 10.4482 29.5508 10.4482C29.009 10.4482 28.5814 10.6788 28.2626 11.1394L27.4076 10.5999C27.8715 9.92673 28.5639 9.58732 29.4852 9.58732ZM28.2328 13.364C28.2328 13.6185 28.3532 13.8551 28.5519 14.0004C28.7686 14.1701 29.0337 14.2609 29.3043 14.2549C29.7137 14.2549 30.1049 14.0912 30.3942 13.8003C30.7134 13.4973 30.8759 13.1395 30.8759 12.7272C30.575 12.4847 30.1533 12.3634 29.6116 12.3634C29.2201 12.3634 28.889 12.4603 28.6243 12.6484C28.3651 12.8429 28.2328 13.0794 28.2328 13.364ZM37.1246 9.75703L33.8856 17.2499H32.8864L34.0903 14.6311L31.9594 9.76303H33.0131L34.5482 13.4973H34.5724L36.0713 9.76303L37.1246 9.75703Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M19.3712 11.2118C19.3712 10.9149 19.347 10.6179 19.2989 10.3269H15.2109V12.0063H17.5528C17.4566 12.5458 17.1434 13.0309 16.6859 13.3339V14.4249H18.0827C18.9014 13.6673 19.3712 12.5458 19.3712 11.2118Z",
						fill: "#517CBE"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M15.2108 15.4799C16.3786 15.4799 17.3659 15.092 18.0825 14.4252L16.6858 13.3342C16.2943 13.6008 15.7947 13.7524 15.2108 13.7524C14.0788 13.7524 13.1217 12.9824 12.7787 11.9521H11.3398V13.0796C12.0744 14.5461 13.5736 15.4799 15.2108 15.4799Z",
						fill: "#32A853"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M12.7789 11.9515C12.5984 11.4119 12.5984 10.824 12.7789 10.2785V9.15698H11.34C10.72 10.3877 10.72 11.8426 11.34 13.0733L12.7789 11.9515Z",
						fill: "#FBBC0C"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_5",
						d: "M15.2108 8.47772C15.8309 8.46571 16.4271 8.70187 16.8722 9.13251L18.1064 7.88977C17.3241 7.14412 16.2887 6.73789 15.2108 6.75028C13.5732 6.75028 12.0744 7.68402 11.3398 9.15691L12.7787 10.2844C13.1221 9.24777 14.0792 8.47772 15.2108 8.47772Z",
						fill: "#E84436"
					})
				]
			})
		})
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13_5710_googlePay_dark",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 26.2496,
			height: 10.4999,
			fill: "white",
			transform: "translate(10.875 6.75)"
		})
	}) })]
});
export default SvgGooglePay;
